"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitializers = exports.runInitializers = void 0;
const use_once_1 = require("../use-once");
const context_1 = require("./context");
const shared_values_model_1 = require("./shared-values.model");
function runInitializers(values, initializers) {
    return Promise.all(initializers.map(initializer => initializer(values)));
}
exports.runInitializers = runInitializers;
function useInitializers(initializers) {
    const values = (0, context_1.useSharedValueStoreContext)();
    (0, use_once_1.useOnceAsync)(() => __awaiter(this, void 0, void 0, function* () {
        yield runInitializers(values, initializers);
        values.dispatch(shared_values_model_1.AppInitialized);
    }));
}
exports.useInitializers = useInitializers;
//# sourceMappingURL=shared-value-initializers.js.map